import React, { useContext, useEffect, useState } from "react";
import { Link, useHistory, useParams } from "react-router-dom";
import { UserContext } from "../../App";
import {
  createCompany,
  deleteCompany,
  updateCompany,
} from "../../utils/company";
import { db } from "../../index";
import { FooterActionsContainer } from "../layout/Footer";
import { OutlineButton } from "../layout/OutlineButton";

export default function CompanyAddOrUpdateContent() {
  const history = useHistory();
  const params = useParams();
  const companyId = params.company_id;

  const { userInfos } = useContext(UserContext);

  const [formError, setFormError] = useState([]);
  const [isFetching, setIsFetching] = useState(false);
  const [company, setCompany] = useState({
    id: "",
    name: "",
    email: "",
    city: "",
    siren: "",
    revtc: "",
    adresse: "",
    tel: "",
    owner: "",
  });

  useEffect(() => {
    if (companyId && userInfos?.uid) {
      if (companyId === userInfos.company?.id) {
        history.push("/profile");
        return;
      }
      db.ref(`users/${userInfos.uid}/company/${companyId}`)
        .once("value", (snapshot) => {
          const res = snapshot.val();
          setCompany({ ...res, id: snapshot.key });
        })
        .then();
    }
  }, [companyId, history, userInfos.company?.id, userInfos.uid]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setCompany((old) => ({
      ...old,
      [name]: value,
    }));
  };

  async function handleDeleteCompany() {
    await deleteCompany(userInfos, companyId);
    history.push("/company");
  }

  async function handleFormSubmit(e) {
    e.preventDefault();
    if (handleValidation()) {
      setIsFetching(true);

      if (companyId) {
        await updateCompany(userInfos, company);
        window.alert("Entreprise mise à jour avec succès");
      } else {
        await createCompany(userInfos, company);
        history.push("/company");
      }

      setIsFetching(false);
    }
  }

  const handleValidation = () => {
    let valid = true;
    let message = [];

    if (company.name === "") {
      valid = false;
      message.push("Veuillez renseigner le nom de l'entreprise");
    }

    setFormError(message);

    return valid;
  };

  const renderFormAlert = () => {
    const alert =
      formError.length > 0 ? (
        <div
          className="alert alert-danger"
          role="alert"
          style={{ flexDirection: "column" }}
        >
          {formError.map((error, index) => {
            return (
              <div
                className="alert-text"
                key={index}
                style={{ alignSelf: "flex-start" }}
              >
                {error}
              </div>
            );
          })}
        </div>
      ) : (
        ""
      );

    return (
      <div className="kt-container  kt-container--fluid  kt-grid__item kt-grid__item--fluid">
        {alert}
      </div>
    );
  };

  const buttonText =
    isFetching === true ? (
      <button type="submit" className="btn btn-primary px-5" disabled>
        {companyId ? "Mise à jour..." : "Création..."}
      </button>
    ) : (
      <button type="submit" className="btn btn-primary px-5">
        {companyId ? "Mettre à jour l'entreprise" : "Créer l'entreprise"}
      </button>
    );

  return (
    <div
      className="kt-content  kt-grid__item kt-grid__item--fluid kt-grid kt-grid--hor"
      id="kt_content"
    >
      <div className="kt-subheader   kt-grid__item" id="kt_subheader">
        <div className="kt-container  kt-container--fluid ">
          <div className="kt-subheader__main">
            <h3 className="kt-subheader__title">
              {companyId ? company?.name : "Créer une entreprise"}{" "}
            </h3>
            <div className="kt-subheader__breadcrumbs">
              <Link to="/" className="kt-subheader__breadcrumbs-home">
                <i className="flaticon2-shelter"></i>
              </Link>
              <span className="kt-subheader__breadcrumbs-separator"></span>
              <Link to="/company/" className="kt-subheader__breadcrumbs-link">
                Entreprises
              </Link>
              {companyId ? (
                <>
                  <span className="kt-subheader__breadcrumbs-separator"></span>
                  <Link
                    to={"/company/" + companyId}
                    className="kt-subheader__breadcrumbs-link"
                  >
                    {company?.name}
                  </Link>
                </>
              ) : null}
            </div>
          </div>
        </div>
      </div>

      {renderFormAlert()}

      <div className="kt-container  kt-container--fluid  kt-grid__item kt-grid__item--fluid">
        <div className="kt-portlet kt-portlet--tabs">
          <div className="kt-portlet__head">
            <div className="kt-portlet__head-label">
              <h3 className="kt-portlet__head-title">
                Données de l'entreprise
              </h3>
            </div>
          </div>
          <form onSubmit={handleFormSubmit} className="kt-form">
            <div className="kt-portlet__body">
              <div className="kt-section kt-section--first">
                <div className="kt-section__body">
                  <div className="form-group row">
                    <label className="col-lg-3 col-form-label">Nom *</label>
                    <div className="col-lg-6">
                      <input
                        type="text"
                        value={company.name}
                        className="form-control"
                        name="name"
                        onChange={handleChange}
                      />
                    </div>
                  </div>
                  <div className="form-group row">
                    <label className="col-lg-3 col-form-label">Email:</label>
                    <div className="col-lg-6">
                      <input
                        value={company.email}
                        type="email"
                        className="form-control"
                        name="email"
                        onChange={handleChange}
                      />
                    </div>
                  </div>
                  <div className="form-group row">
                    <label className="col-lg-3 col-form-label">Ville:</label>
                    <div className="col-lg-6">
                      <input
                        type="text"
                        className="form-control"
                        name="city"
                        value={company.city}
                        onChange={handleChange}
                      />
                    </div>
                  </div>
                  <div className="form-group row">
                    <label className="col-lg-3 col-form-label">SIREN:</label>
                    <div className="col-lg-6">
                      <input
                        type="text"
                        className="form-control"
                        name="siren"
                        value={company.siren}
                        onChange={handleChange}
                      />
                    </div>
                  </div>
                  <div className="form-group row">
                    <label className="col-lg-3 col-form-label">REVTC:</label>
                    <div className="col-lg-6">
                      <input
                        type="text"
                        className="form-control"
                        name="revtc"
                        value={company.revtc || ""}
                        onChange={handleChange}
                        inputMode="numeric"
                        placeholder="Numéro REVTC"
                      />
                    </div>
                  </div>
                  <div className="form-group row">
                    <label className="col-lg-3 col-form-label">Adresse:</label>
                    <div className="col-lg-6">
                      <input
                        type="text"
                        className="form-control"
                        name="adresse"
                        value={company.adresse}
                        onChange={handleChange}
                      />
                    </div>
                  </div>
                  <div className="form-group row">
                    <label className="col-lg-3 col-form-label">
                      Téléphone:
                    </label>
                    <div className="col-lg-6">
                      <input
                        type="tel"
                        className="form-control"
                        name="tel"
                        value={company.tel}
                        onChange={handleChange}
                      />
                    </div>
                  </div>
                  <div className="form-group row">
                    <label className="col-lg-3 col-form-label">Gérant:</label>
                    <div className="col-lg-6">
                      <input
                        type="text"
                        className="form-control"
                        name="owner"
                        value={company.owner}
                        onChange={handleChange}
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <FooterActionsContainer>
              <div>
                <OutlineButton type="button" onClick={history.goBack}>
                  <i className="fas fa-arrow-left" />
                  Retour
                </OutlineButton>
              </div>
              <div>{buttonText}</div>
              <div>
                {companyId && (
                  <OutlineButton
                    type="button"
                    data-toggle="modal"
                    data-target="#delete_modal"
                  >
                    <i className="fas fa-trash-alt" />
                    Supprimer
                  </OutlineButton>
                )}
              </div>
            </FooterActionsContainer>
          </form>
        </div>
      </div>
      <div
        className="modal fade"
        id="delete_modal"
        tabIndex="-1"
        role="dialog"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-dialog-centered" role="document">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title" id="exampleModalLongTitle">
                Supprimer l'entreprise
              </h5>
              <button
                type="button"
                className="close"
                data-dismiss="modal"
                aria-label="Close"
              ></button>
            </div>
            <div className="modal-body">
              <p>Êtes-vous sûr de vouloir supprimer cette entreprise ?</p>
            </div>
            <div className="modal-footer">
              <button
                type="button"
                className="btn btn-secondary"
                data-dismiss="modal"
              >
                Annuler
              </button>
              <button
                type="button"
                className="btn btn-primary"
                data-dismiss="modal"
                onClick={handleDeleteCompany}
              >
                Supprimer
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
